import { RoleTypes } from 'models';

export function checkIsAdmin(role?: Array<string | null> | null | undefined) {
	return role ? role.includes(RoleTypes.admin) : false;
}
